import { Mail } from "lucide-react";
import PSFavicon from "@/assets/images/PS Favicon-01.png";

export default function Footer({ variant = "secondary" }) {
  return (
    <footer className={`bg-${variant} border-t border-secondary-border mt-auto`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src={PSFavicon} 
                alt="Postscrypt" 
                className="w-8 h-8"
              />
              <span className="ml-2 text-xl font-bold text-foreground">Postscrypt</span>
            </div>
            <p className="text-muted-foreground mb-4 max-w-md">
              Preserving life stories and creating lasting legacies for future generations through professional recording and storytelling.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold text-foreground mb-4">Contact</h3>
            <div className="space-y-3 text-sm text-muted-foreground">
              <div className="flex items-center">
                <Mail className="mr-2" size={16} />
                <a href="mailto:postscrypt@rightlegalgroup.com" className="text-[#F16745] hover:underline">
                  postscrypt@rightlegalgroup.com
                </a>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold text-foreground mb-4">Services</h3>
            <div className="space-y-2 text-sm text-muted-foreground">
              <div>In-Person Recording</div>
              <div>Legacy Preservation</div>
              <div>Family Stories</div>
              <div>Video Production</div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-border pt-8 mt-8 text-center text-sm text-muted-foreground">
          <p className="mb-2">
          Copyright 2025 Right Legal Group Limited. Right Legal Group are authorised and regulated by the Solicitors Regulation Authority. SRA Number: 607718. Right Legal Group Limited is a company registered in England and Wales. Registered address: 16 Stanier Way, Wyvern Business Park, Derby, DE21 6BF. Registration number 08276948.
        </p>
          <p>
          For Postscrypt support, please email <a href="mailto:postscrypt@rightlegalgroup.com" target="_blank" rel="noopener noreferrer" className="text-[#F16745] hover:underline">postscrypt@rightlegalgroup.com</a>
        </p>
        </div>
      </div>
    </footer>
  );
}
